"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostOutboundWebhookEventSchema = exports.OutboundWebhookEventsType = void 0;
const zod_1 = require("zod");
var OutboundWebhookEventsType;
(function (OutboundWebhookEventsType) {
    OutboundWebhookEventsType["POST_WEBHOOK"] = "POST_WEBHOOK";
})(OutboundWebhookEventsType = exports.OutboundWebhookEventsType || (exports.OutboundWebhookEventsType = {}));
exports.PostOutboundWebhookEventSchema = zod_1.z.object({
    client_id: zod_1.z.string(),
    webhook_data_id: zod_1.z.number(),
    type: zod_1.z.literal(OutboundWebhookEventsType.POST_WEBHOOK),
});
